import { createFileRoute } from '@tanstack/react-router'
import { RecalcularEventosPage } from '@/pages/recalcular-eventos/RecalcularEventosPage'

type RecalcularEventosSearch = {
  tripId?: string
}

export const Route = createFileRoute('/_auth/recalcular-eventos')({
  validateSearch: (search: RecalcularEventosSearch) => ({
    tripId: typeof search.tripId === 'string' ? search.tripId.trim() || undefined : undefined,
  }),
  component: RecalcularEventosPage,
})
